export const imageRoot =
  "https://storage.googleapis.com/nazo-button.appspot.com/images/";
